import Vue from 'vue'

import Wovn from '@/components/Wovn'

import {
  Button,
  Calendar,
  DatePicker,
  Modal,
  Pagination,
  Rating,
  Stepper,
  Tag,
  Icon,
  BasicCarousel,
  BasicCarouselSearch
} from '@/components/primitive'

import {
  CarouselThumbnail,
  Share,
  InstructionLogin,
  InstructionLogin1,
  InstructionLogin2,
  InstructionLogin3,
  PopUpSendMail,
  RecommendedItem,
  HotelItem,
  SearchBlock,
  FormsKeywordSearch,
  BoxViewMore2
} from '@/components/compound'

Vue.component('Wovn', Wovn)

// primitive
Vue.component('Button', Button)
Vue.component('Calendar', Calendar)
Vue.component('DatePicker', DatePicker)
Vue.component('Modal', Modal)
Vue.component('Pagination', Pagination)
Vue.component('Rating', Rating)
Vue.component('Stepper', Stepper)
Vue.component('Tag', Tag)
Vue.component('Icon', Icon)
Vue.component('BasicCarousel', BasicCarousel)
Vue.component('BasicCarouselSearch', BasicCarouselSearch)

// compound
Vue.component('CarouselThumbnail', CarouselThumbnail)
Vue.component('Share', Share)
Vue.component('InstructionLogin', InstructionLogin)
Vue.component('InstructionLogin1', InstructionLogin1)
Vue.component('InstructionLogin2', InstructionLogin2)
Vue.component('InstructionLogin3', InstructionLogin3)
Vue.component('PopUpSendMail', PopUpSendMail)
Vue.component('RecommendedItem', RecommendedItem)
Vue.component('HotelItem', HotelItem)
Vue.component('SearchBlock', SearchBlock)
Vue.component('FormsKeywordSearch', FormsKeywordSearch)
Vue.component('BoxViewMore2', BoxViewMore2)

import CButton from '@/components/Button'
import ButtonLink from '@/components/ButtonLink'
import Loading from '@/components/Loading'
import LoadingContent from '@/components/LoadingContent'
import LoadingPage from '@/components/LoadingPage'
import ModalDesign from "@/components/ModalDesign";
import ModalError from "@/components/ModalError";
Vue.component('CButton', CButton)
Vue.component('ButtonLink', ButtonLink)
Vue.component('Loading', Loading)
Vue.component('LoadingContent', LoadingContent)
Vue.component('LoadingPage', LoadingPage)
Vue.component("ModalDesign", ModalDesign);
Vue.component("ModalError", ModalError);

// 認証関連
import CommonModal from "@/components/CommonModal";
import AccountModal from '@/components/modal/Account'
import FirstLoginModal from '@/components/modal/FirstLogin'
import ModalCustom from "@/components/ModalCustom/index";
import LoginGuidanceModal from "@/components/modal/LoginGuidance";
Vue.component("CommonModal", CommonModal);
Vue.component('AccountModal', AccountModal)
Vue.component('FirstLoginModal', FirstLoginModal)
Vue.component('ModalCustom', ModalCustom)
Vue.component("LoginGuidanceModal", LoginGuidanceModal);

// CMS
import CMS from '@/components/CMS'
Vue.component("CMS", CMS)
